import React, { useEffect, useState } from "react";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import { useDispatch, useSelector } from "react-redux";
import { setActivated } from "../../../redux/slices/loginSlice";
import { setAddClientButton } from "../../../redux/slices/financialAdvisorSlice";
import AddClientModal from "../../../components/styled-components/modal/addClientModal/AddClientModal";
import { Menu, Dropdown, Tag, Spin, Progress } from "antd";
import moment from "moment";
import "antd/dist/antd.css";
import "./ClientDetails.css";

const ClientDetails = ({
  data,
  deleteClient,
  activateFinancialAdvisorClient,
  deactivateFinancialAdvisorClient,
  prospectPassClient,
  prospectPassUsedData,
  processingStatus,
  offboardFinancialAdvisorClient,
  isActionLoading,
}) => {
  const [accessableUsers, setAccessableUsers] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  const [timeUntilReactivation, setTimeUntilReactivation] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    zipCode: "",
  });

  const dispatch = useDispatch();
  const activated = useSelector(
    (state) => state.rootReducer.loginUser.activated
  );

  const isShowClientBtn = useSelector(
    (state) => state.rootReducer.financialAdvisor.showAddClientButton
  );
  const users =
    localStorage.getItem("delegateUsers") !== "undefined" &&
    JSON.parse(localStorage.getItem("delegateUsers"));

  useEffect(() => {
    const users =
      localStorage.getItem("delegateUsers") !== "undefined" &&
      JSON.parse(localStorage.getItem("delegateUsers"));
    setAccessableUsers(users);
  }, [activated]);

  // Calculate time until reactivation (24 hours from deactivatedAt)
  useEffect(() => {
    if (!data || !data.deactivatedAt) {
      setTimeUntilReactivation("");
      return;
    }

    const updateTimer = () => {
      const deactivatedTime = moment(data.deactivatedAt);
      const reactivationTime = deactivatedTime.clone().add(24, "hours");
      const now = moment();

      if (now.isBefore(reactivationTime)) {
        const duration = moment.duration(reactivationTime.diff(now));
        const formatted = `${Math.floor(
          duration.asHours()
        )}h ${duration.minutes()}m ${duration.seconds()}s`;
        setTimeUntilReactivation(formatted);
      } else {
        setTimeUntilReactivation("");
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [data.deactivatedAt]);

  const handleAccessClient = (clientData) => {
    // console.log("clientData", clientData);
    dispatch(setAddClientButton(false));

    clientData && handleClick(clientData.client.id);
    localStorage.setItem("accessId", clientData.client.id);

    if (!localStorage.getItem("duplicateRole")) {
      localStorage.setItem("duplicateRole", localStorage.getItem("role"));
    }

    localStorage.setItem("role", JSON.stringify("Financial Advisor Client"));
    localStorage.setItem("financialAccess", JSON.stringify(clientData));

    dispatch(setActivated(!activated));
  };

  const handleClick = (id) => {
    console.log("id", id);
    users &&
      users.map((item) => {
        if (id === item.client.id) {
          item["Status"] = true;
          localStorage.setItem("delegateUsers", JSON.stringify(users));
        } else {
          item["Status"] = false;
        }
        return item;
      });
  };

  const isClientActive = data && data.isActive;
  const isClientAccessed =
    data && data.client && data.client.id == localStorage.getItem("accessId");

  return (
    <div className="clientDetailsCard">
      {isActionLoading && (
        <div className="action-loading-overlay">
          <Spin size="large" />
        </div>
      )}
      <div className="clientDetailsCardHeader">
        <div className="headerRow">
          <h1 className="clientDetailsHeading">Client Details</h1>

          <div className="headerActions">
            {processingStatus && processingStatus.progress < 100 && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: '12px',
                padding: '6px 12px',
                background: '#e6f7ff',
                borderRadius: '4px',
                border: '1px solid #91d5ff'
              }}>
                <Spin size="small" style={{ marginRight: '8px' }} />
                <div style={{ display: 'flex', flexDirection: 'column', minWidth: '120px' }}>
                  <span style={{ fontSize: '12px', fontWeight: '500', color: '#1890ff', marginBottom: '2px' }}>
                    Processing Data...
                  </span>
                  <Progress
                    percent={processingStatus.progress}
                    size="small"
                    status="active"
                    strokeColor={{
                      '0%': '#108ee9',
                      '100%': '#87d068',
                    }}
                  />
                </div>
              </div>
            )}
            {prospectPassUsedData && Array.isArray(prospectPassUsedData) && prospectPassUsedData.some(pass => pass.clientId === data.client.id) && (
              <Tag color="orange" style={{ marginRight: '8px', fontWeight: '500', fontSize: '14px' }}>🎁 Prospect Pass Used</Tag>
            )}
            {isClientAccessed ? (
              <button className="accessClientBtn accessClientBtnActive">
                ✓ Activated
              </button>
            ) : (
              <button
                className="accessClientBtn"
                onClick={() => handleAccessClient(data)}
              >
                Access Client
              </button>
            )}

            <div className="filterIcons">
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu style={{ width: 120 }}>
                    <Menu.Item key="view">
                      <div
                        onClick={() => {
                          setModalVisible(true);
                          const clientData = data.client;
                          setFormData({
                            name: clientData.name || "",
                            username: clientData.userName || "",
                            email: clientData.email || "",
                            phone:
                              clientData.phoneNumber &&
                                clientData.phoneNumber.includes("+")
                                ? clientData.phoneNumber
                                : `+92 ${clientData.phoneNumber || ""}`,
                            zipCode: clientData.zipCode || "",
                            image: clientData.image || "",
                          });
                        }}
                      >
                        View
                      </div>
                    </Menu.Item>

                    {!isClientActive ? (
                      [
                        <Menu.Item key="activate">
                          <div
                            onClick={() => {
                              activateFinancialAdvisorClient(
                                data.client.id,
                                data.client
                              );
                            }}
                            style={{ color: "#52c41a" }}
                          >
                            Activate
                          </div>
                        </Menu.Item>,

                        <Menu.Item
                          key="prospectPass"
                          disabled={data && data.prospectPassUsed}
                        >
                          <div
                            onClick={() => {
                              if (!data.prospectPassUsed) {
                                prospectPassClient(data.client.id, data.client);
                              }
                            }}
                            style={{
                              color:
                                data && data.prospectPassUsed
                                  ? "#d9d9d9"
                                  : "#1890ff",
                              cursor:
                                data && data.prospectPassUsed
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            {data && data.prospectPassUsed
                              ? "Prospect Pass Used"
                              : "Prospect Pass"}
                          </div>
                        </Menu.Item>,
                      ]
                    ) : (
                      <Menu.Item key="deactivate">
                        <div
                          onClick={() => {
                            deactivateFinancialAdvisorClient(
                              data.client.id,
                              data.client
                            );
                          }}
                          style={{ color: "#ff4d4f" }}
                        >
                          Deactivate
                        </div>
                      </Menu.Item>
                    )}

                    {isShowClientBtn && (
                      <Menu.Item key="offboard">
                        <div
                          onClick={() => {
                            offboardFinancialAdvisorClient(
                              data.client.id,
                              { ...data.client, offBoard: true }
                            );
                          }}
                          style={{ color: "#faad14" }}
                        >
                          Off-board Client
                        </div>
                      </Menu.Item>
                    )}

                    {isShowClientBtn && (
                      <Menu.Item key="delete">
                        <div
                          onClick={() => {
                            deleteClient(data.client.id, data.client);
                          }}
                          style={{ color: "#ff7a45" }}
                        >
                          Delete
                        </div>
                      </Menu.Item>
                    )}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                  style={{ padding: "0px 1rem" }}
                >
                  <img src={menuIcon} height={15} width={4} alt="icon"></img>
                </a>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      {data && !isClientActive && timeUntilReactivation && (
        <div className="reactivationTimer">
          <span>⏱️ Can reactivate in: {timeUntilReactivation}</span>
        </div>
      )}

      <div className="clientDetailsCardFooter">
        <div className="footerItems">
          <div className="footerItemTitle">Spouse</div>
          <div
            className="footerItemSubTitle footerItemSubTitleTruncate"
            title={
              data &&
                data.clientContacts &&
                data.clientContacts[0] &&
                data.clientContacts[0].name
                ? data.clientContacts[0].name
                : "N/A"
            }
          >
            {data &&
              data.clientContacts &&
              data.clientContacts[0] &&
              data.clientContacts[0].name
              ? data.clientContacts[0].name
              : "N/A"}
          </div>
        </div>

        <div className="footerItems">
          <div className="footerItemTitle">Investment Balance</div>
          <div className="footerItemSubTitle">
            {data && data.investmentBalance
              ? `$${(+data.investmentBalance)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"}
          </div>
        </div>

        <div className="footerItems">
          <div className="footerItemTitle">Client Portal Access</div>
          <div className="footerItemSubTitle">
            <Tag
              color={
                data && data.status === "Password Updated" ? "green" : "red"
              }
            >
              {data && data.status === "Password Updated" ? "✓ Yes" : "✗ No"}
            </Tag>
          </div>
        </div>

        <div className="footerItems">
          <div className="footerItemTitle">Last Login</div>
          <div className="footerItemSubTitle">
            {data && data.client && data.client.lastLogin
              ? moment(data.client.lastLogin).local().format("MM/DD/YYYY HH:mm")
              : "Never"}
          </div>
        </div>

        <div className="footerItems">
          <div className="footerItemTitle">Status</div>
          <div className="footerItemSubTitle">
            {data && data.isActive ? (
              <span style={{ color: "#52c41a", fontWeight: "600" }}>
                🟢 Active
              </span>
            ) : (
              <span style={{ color: "#ff4d4f", fontWeight: "600" }}>
                🔴 Inactive
              </span>
            )}
          </div>
        </div>
      </div>

      {isModalVisible && (
        <AddClientModal
          open={isModalVisible}
          onCancel={() => {
            setModalVisible(false);
          }}
          formData={formData}
          setFormData={setFormData}
          readOnly={true}
        />
      )}
    </div>
  );
};

export default ClientDetails;
